// Enter key is disabled from triggering a PDF export
const VisualStatic = require('visual-static');
const FormFields = require('form-fields');

class Form extends VisualStatic {
  init() {
    this.orderOfFormFields = ['payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_statutory_ind', 'payee1_retirement_plan_ind', 'payee1_third_party_sick_pay_ind', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

    this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

    this.initOnReactComponentsMounted();
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();

    VisualStatic.setTabOrder(this.orderOfFormFields);

    // Remove labels (they are basically duplicates)
    VisualStatic.setPlaceholders(this.removeLabelsFromFields);

    // Hide the eFiling option for upaid users
    if (!window.SessionManager.isPaidUser) {
      const eFileElm = document.getElementById('efileDocument');
      if (eFileElm) {
        eFileElm.style.display = 'none';
      }
      document.getElementById('group_efiling_subheading').style.display = 'none';
      document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
      document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
      document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

      // group_efiling_subheading is not displayed, which affects positioning of country fields
      document.getElementById('group_payee1_country').style.top = '-3042px';
      document.getElementById('group_payer_country').style.top = '-3355px';
    }

    // Disables default dropdown option for W2 additional fields:
    // payee1_employment_type and payer_kind_of_employer
    VisualStatic.disableW2SelectDefaultOption();

    // Attach button events
    VisualStatic.initExportPDF();

    // [E-file] Context on the E-file flow at this stage:
    // When the e-filing button is clicked, we validate that required fields are added and
    // that certain fields have passed regex validation. Once all specified fields pass validation,
    // we should save the document session and redirect to the taxFiling page.
    const eFileButton = document.getElementById('efileDocument');
    if (eFileButton) {
      eFileButton.addEventListener('click', (e) => {
        const requiredFields = [
          'payee1_address1',
          'payee1_city',
          'payee1_country',
          'payee1_employment_type',
          'payee1_first_name',
          'payee1_last_name',
          'payee1_state',
          'payee1_tin',
          'payee1_zipcode',
          'payer_address1',
          'payer_city',
          'payer_company_name1',
          'payer_country',
          'payer_kind_of_employer',
          'payer_phone',
          'payer_state',
          'payer_tin',
          'payer_zipcode',
        ];

        const hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
        if (!hasRequiredFields) {
          e.preventDefault();
          return false;
        }

        const currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
        const stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
        const tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
        const payeeCodeRegex = { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' };
        const localNameRegex = { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' };
        const regexValidations = {
          payer_tin: tinRegex,
          payee1_tin: tinRegex,
          payee1_code_a: payeeCodeRegex,
          payee1_code_b: payeeCodeRegex,
          payee1_code_c: payeeCodeRegex,
          payee1_code_d: payeeCodeRegex,
          payee1_amt_a: currencyRegex,
          payee1_amt_b: currencyRegex,
          payee1_amt_c: currencyRegex,
          payee1_amt_d: currencyRegex,
          payer_state: stateRegex,
          payee1_state: stateRegex,
          payee1_state_name_one: stateRegex,
          payee1_state_name_two: stateRegex,
          payee1_local_name_one: localNameRegex,
          payee1_local_name_two: localNameRegex,
          payee1_allocated_tips: currencyRegex,
          payee1_dependent_care_benefits: currencyRegex,
          payee1_fit_withh: currencyRegex,
          payee1_local_tax_withh_one: currencyRegex,
          payee1_local_tax_withh_two: currencyRegex,
          payee1_local_wages_tips_etc_one: currencyRegex,
          payee1_local_wages_tips_etc_two: currencyRegex,
          payee1_medicare_withh: currencyRegex,
          payee1_med_wages_and_tips: currencyRegex,
          payee1_non_qual457: currencyRegex,
          payee1_non_qual_non457: currencyRegex,
          payee1_soc_sec_tips: currencyRegex,
          payee1_soc_sec_wages: currencyRegex,
          payee1_soc_sec_withh: currencyRegex,
          payee1_state_tax_withh_one: currencyRegex,
          payee1_state_tax_withh_two: currencyRegex,
          payee1_state_wages_tips_etc_one: currencyRegex,
          payee1_state_wages_tips_etc_two: currencyRegex,
          payee1_wages_tips_other_comp: currencyRegex,
        };
        const validFields = FormFields.validateFields(regexValidations);
        if (!validFields) {
          e.preventDefault();
          return false;
        }

        // Validations passed, save and submit
        return window.SessionManager.save(() => (true));
      });
    }
  }
}

module.exports = Form;



// WEBPACK FOOTER //
// ./src-assets/js/form-w2-efile-2022.js